import LegalPage from "@/components/LegalPage";
import { IMPRESSUM, SITE } from "@/data/site";

export default function Impressum() {
  return (
    <LegalPage title="Impressum" testid="impressum-page">
      <h2>Angaben gemäß § 5 DDG</h2>
      <p>
        <strong>{IMPRESSUM.name}</strong>
        <br />
        Deutschland
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon (auch WhatsApp): <strong>{SITE.phoneDisplay}</strong>
        <br />
        E-Mail: {IMPRESSUM.email}
      </p>
      <p>
        Am schnellsten erreichst du uns über die <strong>WhatsApp-Buttons</strong> auf
        unserer Startseite — jede Nachricht wird persönlich beantwortet.
        Die genaue Anschrift geben wir auf Nachfrage direkt per WhatsApp mit.
      </p>

      <h2>Umsatzsteuer</h2>
      <p>
        Gemäß <strong>§ 19 UStG</strong> (Kleinunternehmerregelung) wird keine
        Umsatzsteuer berechnet und daher auch nicht ausgewiesen.
      </p>

      <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>{IMPRESSUM.name}</p>

      <h2>Streitschlichtung</h2>
      <p>
        Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </LegalPage>
  );
}
